module.exports = __webpack_public_path__ + "static/media/hirama_03.faa47ab3.jpg";